import { NgModule }              from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { CommunicationCenterComponent } from './communication-center.component';
import { CommunicationCenterService }   from './communication-center.service';
import { CommunicationCenterStates }    from './communication-center.states';
import { SharedModule }                 from '../shared/shared.module';
import { TableModule }                  from '../table/table.module';

@NgModule({
  declarations: [
    CommunicationCenterComponent
  ],
  entryComponents: [
    CommunicationCenterComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterModule.forChild({ states: CommunicationCenterStates })
  ],
  providers: [
    CommunicationCenterService
  ]
})
export class CommunicationCenterModule {}
